import { useCallback, useEffect, useState } from "react";
import { myBonuses } from "../../api/bonuses";
import { useAuth } from "../../context/AuthContext";

// يجلب مكافآتي المعلّقة لعرض نافذة تأكيد الاستلام الإلزامية في أي شاشة.
export const useAwaitingBonus = () => {
  const { user } = useAuth();
  const [awaiting, setAwaiting] = useState([]);

  const load = useCallback(async () => {
    if (!user) return;
    try {
      const data = await myBonuses();
      setAwaiting(data.awaiting || (data.items || []).filter((b) => b.awaiting_receipt));
    } catch {
      setAwaiting([]);
    }
  }, [user]);

  useEffect(() => {
    load();
  }, [load]);

  return { awaiting, reload: load };
};
